import { NgTemplateOutlet } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  TemplateRef,
  inject,
} from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { ClipboardCopy, IconButtonComponent, RtTooltip } from '@core/user-interface-legacy';

export type CandidateFieldRow = {
  value: string;
  isValid?: boolean;
};

@Component({
  selector: 'rt-candidate-field-row',
  imports: [IconButtonComponent, TranslatePipe, RtTooltip, NgTemplateOutlet],
  templateUrl: './candidate-field-row.component.html',
  styleUrl: './candidate-field-row.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateFieldRowComponent {
  private readonly clipboardCopy = inject(ClipboardCopy);

  public name = input.required<string>();
  public copyable = input<boolean>(false);
  public editable = input<boolean>(false);
  public editing = input<boolean>(false);
  public displayInline = input<boolean>(false);
  public field = input<CandidateFieldRow[] | null>();
  public fieldDisplayTpl = input<TemplateRef<any>>();
  public fieldEditTpl = input<TemplateRef<any>>();
  public tooltipEnabled = input<boolean>(false);
  public tooltipText = input<string>();
  public wrap = input<boolean, string | boolean>(false, { transform: booleanAttribute });

  public edit = output<void>();

  public copyToClipboard(value: string): void {
    this.clipboardCopy.fromString(value);
  }
}
